// Composables
import {createRouter, createWebHashHistory} from 'vue-router';
import ChatPage from '@/views/ChatPage.vue';
import Disclaimer from '@/views/Disclaimer.vue';
import CasLogin from '@/views/CasLogin.vue';
import UnauthorizedPage from '@/views/UnauthorizedPage.vue';
import casRouteGuard from '../guards/casRouteGuard.js'; // Adjust path accordingly
import disclaimerRouteGuard from '../guards/disclaimerRouteGuard.js';
import queryParamRouteGuard from '../guards/queryParamRouteGuard.js'
const useCASRouteGuard = true; // Turn false to turn off CAS for testing


const routes = [
  {
    path: '/unauthorized',
    component: UnauthorizedPage
  },
  {
    path: '/disclaimer/:botName',
    component: Disclaimer,
    props:true
  },
  {
    path: '/login',
    component: CasLogin,
  },
  {
    path: '/botName/:botName',
    component: ChatPage,
    beforeEnter: useCASRouteGuard ? [casRouteGuard, disclaimerRouteGuard] : undefined,
  },
  {
    path: '/',
    component: ChatPage,
    beforeEnter: useCASRouteGuard ? [ queryParamRouteGuard, casRouteGuard, disclaimerRouteGuard] : [queryParamRouteGuard],
    props: route => ({botName: route.query.botName, streaming: route.query.streaming }),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: routes,
});

export default router;
